import { createContext, RefObject } from 'react';

export const ModalPanelContext = createContext<RefObject<HTMLDivElement | undefined> | undefined>(undefined);

export default ModalPanelContext;
